import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AnyObject } from 'src/commons';
import { API_URL } from '../../config';

const Axios = axios.create({ baseURL: API_URL });
Axios.defaults.headers.post['Content-Type'] = 'application/json';

export { Axios };

class AxiosRequest {
  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    try {
      const result = await Axios.get<T>(url, config);
      return result;
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 412) window.location.reload();
      throw error;
    }
  }

  async post<T = any>(url: string, data?: AnyObject, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    try {
      const result = await Axios.post<T>(url, data, config);
      return result;
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 412) window.location.reload();
      throw error;
    }
  }

  async put<T = any>(url: string, data?: AnyObject, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    try {
      const result = await Axios.put<T>(url, data, config);
      return result;
    } catch (error: any) {
      const status = error?.response?.status;
      if (status === 412) window.location.reload();
      throw error;
    }
  }
}

const i = new AxiosRequest();
export { i as AxiosRequest };
